import { buildQuery, containsQuery } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/catalogs";

const getList = (entityTypes: string[] | undefined) => {
    const filter = entityTypes
        ? `?${new URLSearchParams(entityTypes.map((item) => ["entityTypes", item])).toString()}`
        : "";
    return request(`${resource}/getUserEntityOptionsWithDefaults${filter}`, { method: "GET" });
};

const index = () => {
    return request(`${resource}/getUserEntityOptions`, { method: "GET" }).then((res) =>
        res && res.length > 0 ? formatOrganizationCatalogs(res) : res,
    );
};

const systemCatalogs = () =>
    request(
        `${resource}/getSimple${buildQuery({ filter: { organizationId: { ne: null } } })}`,
        { method: "GET" },
        { countInHeaders: true },
    );

const getItem = (params: { id: string }) => {
    const query = buildQuery({ filter: { entityOptionId: parseInt(params.id) } });
    return request(`${resource}/getUserEntityOptions${query}`, { method: "GET" }).then(
        (data) => data && data.length > 0 && data[0],
    );
};

const apply = (params: {}) => alertRequest(`${resource}/applyUserEntityOption`, body(params));

const getProperties = () => request(`${resource}/getProperties`, { method: "GET" });

const applyOrganizationCatalog = (params: {}) => alertRequest(`${resource}/applyOrganizationCatalog`, body(params));

const applyOrganizationEntityOption = (params: {}) =>
    alertRequest(`${resource}/applyOrganizationEntityOption`, body(params));

const applyOrganizationItem = (params: {}) => alertRequest(`${resource}/applyOrganizationItem`, body(params));

const deleteOrganizationEntityOption = (params: {}) =>
    alertRequest(`${resource}/deleteOrganizationEntityOption`, body(params));

const delCatalog = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const delItem = (params: {}) => alertRequest(`${resource}/deleteItem`, body(params));

const restoreItem = (params: {}) => alertRequest(`${resource}/restoreItem`, body(params));

const formatOrganizationCatalogs = (res: { catalogPropertyName: string | undefined }[]) => {
    const data = res.filter((item) => item.catalogPropertyName);
    return { data, count: data.length };
};

const getUsedCarTypes = (params: {}) =>
    request(`${resource}/getUsedCarTypes${containsQuery(params)}`, { method: "GET" });

const getUsedTrailerTypes = (params: {}) =>
    request(`${resource}/getUsedTrailerTypes${containsQuery(params)}`, { method: "GET" });

export {
    getList,
    apply,
    getProperties,
    applyOrganizationCatalog,
    index,
    getItem,
    applyOrganizationEntityOption,
    deleteOrganizationEntityOption,
    applyOrganizationItem,
    delCatalog,
    delItem,
    restoreItem,
    systemCatalogs,
    getUsedCarTypes,
    getUsedTrailerTypes,
};
